import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Select, {SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text"
import Alert from "@amzn/meridian/alert"
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint, getNodeId} from "../../Utils";
import {fetchAllPrograms} from "../../NetworkUtils";
import {
    ALERT_TYPES,
    LAUNCH_STATUS_CSV_HEADER,
    LAUNCH_STATUS_HEADERS,
    LAUNCH_STATUS_IDENTIFIER,
    LAUNCH_STATUS_LIST_IDENTIFIER,
    LAUNCH_STATUS_STATES,
    STATION_CODE,
    VALUE
} from "../../Constants";
import Divider from "@amzn/meridian/divider";
import Button from "@amzn/meridian/button"
import Box from "@amzn/meridian/box";
import Loader from "@amzn/meridian/loader";
import {ProgramLaunchStatusTable} from "./ProgramLaunchStatusTable";
import axios from "axios";
import {exportToCsv} from "../../handler/CsvHandler";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/RouteConstants";

const ProgramLaunchStatus = () => {

    const [programName, setProgramName] = useState();
    const [alert, setAlert] = useState({visible: false, text:"", type:"0"});
    const [loading, setLoadingValue] = useState({visible: false, showTable : false});
    const [programList, setProgramList] = useState([]);
    const [unsupportedConfigsList, setUnsupportedConfigList] = useState({unsupportedConfigString: "", unsupportedConfigList : [], supportedConfigsList : []});
    const [programLaunchStatusList, setprogramLaunchStatusList] = useState([]);
    const [programLaunchDataSegregated, setProgramLaunchDataSegregated] = useState([{enabledStations: 0, disabledStations: 0, partiallyEnabledStations: 0, allStations: 0}]);
    const warningAlert = {visible: true, text: "Program launch status request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully shared Program launch status", type:ALERT_TYPES.SUCCESS};
    const nodeId = getNodeId();

    useEffect(() => {
        fetchAllPrograms().then(response => setProgramList(response))
    }, []);


    useEffect(() => {
        if(programName!==undefined)
        {
            setprogramLaunchStatusList([]);
            setAlert(warningAlert);
            setLoadingValue({visible: true, showTable : false});
             fetchProgramLaunchStatus(programName, nodeId).then(response => {
                 let launchStationListFromResponse = prepareLaunchStationList(response.featureStationsList);
                 setprogramLaunchStatusList(launchStationListFromResponse);

            });
        }
    }, [programName]);

    useEffect(() => {
        if(programLaunchStatusList.length !== 0) {
            setLoadingValue({visible: false, showTable : true});
            setCumulativeProgramLaunchStatusList(programLaunchStatusList);
        }
    }, [programLaunchStatusList]);

    const prepareLaunchStationList = (featureStations) => {
        return featureStations.map(({
                                        feature,
                                        featureDisabledStationsList,
                                        featureEnabledStationsList,
                                        rootStationCode,
                                        unsupportedConfig
                                    }) => ({
            FEATURE : feature || "",
            DISABLED_STATIONS_FOR_FEATURE: featureDisabledStationsList || [],
            ENABLED_STATIONS_FOR_FEATURE: featureEnabledStationsList || [],
            ROOT_STATION: rootStationCode,
            UNSUPPORTED_CONFIG : unsupportedConfig
        }));
    };

    const exportDataToCsv = () => {
        let programLaunchExportDataList = [];
        let csvHeadersList = [LAUNCH_STATUS_CSV_HEADER.STATION], featureList = [], allStationsList = [], cumulativeRootEnabledList = [];
        programLaunchStatusList.forEach(function (arrayItem) {
            csvHeadersList.push(arrayItem.FEATURE);
            featureList.push(arrayItem.FEATURE);
        });
        //Final column for aggregated values for each station
        csvHeadersList.push(LAUNCH_STATUS_CSV_HEADER.PROGRAM_STATUS);

        // Mapping allStations = Enabled + Disabled stations for any feature
        for(let i = 0;i<(programLaunchStatusList[0].ENABLED_STATIONS_FOR_FEATURE.length) ;i++)
        {
            allStationsList.push(programLaunchStatusList[0].ENABLED_STATIONS_FOR_FEATURE[i][STATION_CODE]);
        }

        for(let i = 0;i<(programLaunchStatusList[0].DISABLED_STATIONS_FOR_FEATURE.length) ;i++)
        {
            allStationsList.push(programLaunchStatusList[0].DISABLED_STATIONS_FOR_FEATURE[i][STATION_CODE]);
        }

        for(let i = 0;i<(allStationsList.length) ;i++) {
            let currentEnabledStationsCount = 0, currentDisabledStationsCount = 0;
            let programLaunchExportData = [];

            programLaunchExportData.splice(0,0,allStationsList[i]);
            programLaunchStatusList.forEach(function (arrayItem) {
                let stations = [];
                let values = [];
                arrayItem.ENABLED_STATIONS_FOR_FEATURE.forEach(d => {
                    stations.push(d[STATION_CODE])
                    values.push(d[VALUE])
                })
                if(stations.includes(allStationsList[i]))
                {
                    let stationIndex = stations.indexOf(allStationsList[i]);
                    if(values[stationIndex]) {
                        // if we have value available for a station then we want to display that value and not "YES" in report
                        programLaunchExportData.splice(featureList.indexOf(arrayItem.FEATURE)+1,0, values[stationIndex]);
                    } else {
                        programLaunchExportData.splice(featureList.indexOf(arrayItem.FEATURE)+1,0, LAUNCH_STATUS_IDENTIFIER.LAUNCH_STATUS_YES);
                    }
                    currentEnabledStationsCount++;
                }
                else
                {
                    programLaunchExportData.splice(featureList.indexOf(arrayItem.FEATURE)+1,0, LAUNCH_STATUS_IDENTIFIER.LAUNCH_STATUS_NO);
                    currentDisabledStationsCount++;
                }
            });
            if(currentEnabledStationsCount === featureList.length)
            {
                programLaunchExportData.push(LAUNCH_STATUS_STATES.ENABLED);
            }
            else if(currentDisabledStationsCount === featureList.length)
            {
                programLaunchExportData.push(LAUNCH_STATUS_STATES.DISABLED);
            }
            else  programLaunchExportData.push(LAUNCH_STATUS_STATES.PARTIALLY_ENABLED);

            programLaunchExportDataList.push(programLaunchExportData);

        }

        //Add cumulative data details at the end of CSV:
        cumulativeRootEnabledList.push(nodeId);
        programLaunchStatusList.forEach(function (arrayItem) {
            cumulativeRootEnabledList.splice(featureList.indexOf(arrayItem.FEATURE)+1,0,
                "Enabled Stations: " + arrayItem.ENABLED_STATIONS_FOR_FEATURE.length);
        });
        programLaunchExportDataList.push(cumulativeRootEnabledList);

        //export to CSV Function with preprocessed information
        exportToCsv({
            title: `${programName}-Launch Status`,
            headers: csvHeadersList,
            rows: programLaunchExportDataList
        })};

    function removeUnsupportedConfigsFromLaunchStatus(featureStations) {
        //remove unsupported configs list item and add in unsupportedConfig
        let supportedConfigs = [], unsupportedConfigs = [],
            unsupportedConfigsString = "Unsupported Configs for Launch Status : ";
        featureStations.forEach(function (arrayItem) {
            if(arrayItem.UNSUPPORTED_CONFIG.length === 0 && arrayItem.UNSUPPORTED_CONFIG === "")
            {
                supportedConfigs.push(arrayItem);
            }
            else
            {
                unsupportedConfigs.push(arrayItem.UNSUPPORTED_CONFIG);
            }
        });
        unsupportedConfigsString = unsupportedConfigsString.concat(unsupportedConfigs.join(" , "));
        setUnsupportedConfigList({unsupportedConfigString:unsupportedConfigsString ,
            unsupportedConfigList : unsupportedConfigs , supportedConfigsList: supportedConfigs});

        return supportedConfigs;
    }

    async function fetchProgramLaunchStatus (programName, nodeId) {
        const getProgramsLaunchStatusHeaders = await getHeadersForNFMS("GetProgramLaunchStatus");
        return axios
            .post(getNFMSEndpoint(), {programId: programName, nodeId: nodeId}, getProgramsLaunchStatusHeaders)
            .then((response) => {
                if (response.status === 200) {
                    console.log("response.data " , response.data);
                    setAlert(successAlert);
                    return response.data;
                }
            })
            .catch((response) => {
                setAlert(getErrorAlertObjectFromResponse(response));
                setLoadingValue({visible: false, showTable: false});
            })
    }

    function setCumulativeProgramLaunchStatusList(programLaunchStatusList) {
        let programLaunchStatusListFiltered = removeUnsupportedConfigsFromLaunchStatus(programLaunchStatusList);
        if(programLaunchStatusListFiltered.length !== 0) {

            let enabledStations = [], disabledStations = [], partiallyEnabledStations = [];
            programLaunchStatusListFiltered[0].ENABLED_STATIONS_FOR_FEATURE.forEach(function (arrayItem) {
                enabledStations.push(arrayItem[STATION_CODE])
            });

            programLaunchStatusListFiltered[0].DISABLED_STATIONS_FOR_FEATURE.forEach(function (arrayItem) {
                disabledStations.push(arrayItem[STATION_CODE])
            });

            let allStations = enabledStations.concat(disabledStations);

            for(let i = 1; i < programLaunchStatusListFiltered.length; i++)
            {
                let currEnabledStations = [];
                programLaunchStatusListFiltered[i].ENABLED_STATIONS_FOR_FEATURE.forEach(function (arrayItem) {
                    currEnabledStations.push(arrayItem[STATION_CODE])
                });

                let currDisabledStations = [];
                programLaunchStatusListFiltered[i].DISABLED_STATIONS_FOR_FEATURE.forEach(function (arrayItem) {
                    currDisabledStations.push(arrayItem[STATION_CODE])
                });
                enabledStations = enabledStations.filter(x => currEnabledStations.includes(x));
                disabledStations = disabledStations.filter(x => currDisabledStations.includes(x));
            }

            partiallyEnabledStations = allStations.filter( ( station ) => !(enabledStations.concat(disabledStations)).includes( station ) );

            setProgramLaunchDataSegregated({  enabledStations: enabledStations.length,
                disabledStations: disabledStations.length,
                partiallyEnabledStations : partiallyEnabledStations.length,
                allStations: enabledStations.length + disabledStations.length + partiallyEnabledStations.length
            });
        }
    }

    function GetUnsupportedConfigsAlert() {
        if(unsupportedConfigsList.unsupportedConfigList.length === 0)
        { return (
                <Row spacingInset="large large large large"/>
            );
        }
        else {
            return (
                <Row spacingInset="large large large large">
                    <Alert  type={"informational"}>{unsupportedConfigsList.unsupportedConfigString}</Alert>
                </Row>
            );
        }
    }


    function GetLaunchDataTable() {
            if(loading.showTable===false && loading.visible===true ) {
                 return (<Row alignmentHorizontal="center" alignmentVertical="center" spacingInset="large large none none"><Loader/></Row>);
            } else{
                return (
                    <Box>
                        <ProgramLaunchStatusTable headers={LAUNCH_STATUS_HEADERS} contents={unsupportedConfigsList.supportedConfigsList}
                                                  cumulativeProgramLaunchData = {programLaunchDataSegregated}
                                                  identifier={LAUNCH_STATUS_LIST_IDENTIFIER} programName={programName}/>
                    </Box>
                );
            }

    }

    return (
        <div className="App">
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="none none medium large">
                <Row widths={["grid-12"]} alignmentVertical="top" >
                    <PageHeader {...PAGE_HEADERS.PROGRAM_LAUNCH_STATUS} />
                </Row>
            </Row>

            <Row width="100%" widths={["grid-12"]} alignmentVertical="top" spacingInset="medium none medium large">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="programLaunchStatus.programName" defaultMessage="Program Name"/>
                    </Text>
                    <Row width="100%" widths={["grid-10","grid-2" ]}>
                    <Box >
                        <Row width="100%" >
                            <Select value={programName} onChange={setProgramName} placeholder="Select Program Name" width={400}>
                                {programList.map(program => (
                                    <SelectOption label={program} value={program} key={program} />
                                ))}
                            </Select>
                        </Row>
                    </Box>
                    <Box >
                        <Row width="100%" >
                            <Button onClick={() =>exportDataToCsv()} type="tertiary" size="medium" alignmentHorizontal="right" >
                                <Text>Export To CSV</Text>
                            </Button>
                        </Row>
                    </Box>
                    </Row>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="none none medium large">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>

            <Row width="100%" spacingInset={"large large small small"}>
                <Divider size="medium"/>
            </Row>
            <GetUnsupportedConfigsAlert/>
            <GetLaunchDataTable/>
        </div>
    );
}

export default injectIntl(ProgramLaunchStatus);




// WEBPACK FOOTER //
// ./src/components/program-launch-status/ProgramLaunchStatus.js